<div class="chatbot-container">
    <chatbot [content]='content'></chatbot>
</div>
